<template>
  <div class="consumer-gift-card-auth">
    <pay-and-get-offer v-if="offer" :branding="branding" :restricted="restricted">
      <template #extraContent>
        <div style="width: 100%">
          <merchants-modal class="link-merchants" :offer_id="offer.id">
            <template #activator="{ on, attrs }">
              <h-link class="link-merchants" large v-bind="attrs" v-on="on">{{ $t('components.consumer_gift_card_payment_success.cta_merchants') }}</h-link>
            </template>
          </merchants-modal>
        </div>
        <div style="width: 100%">
          <consumer-gift-card-info-modal :show-action="false" :large-link="true" />
        </div>
      </template>
    </pay-and-get-offer>
    <h-promotion-progress-bar
      class="purchase-promotion-progress-bar"
      style="margin: var(--gap) 0"
      v-if="offer.current_promotion"
      :image-url="currentPromotionBrandingImage"
      :title="currentPromotionBrandingLabel"
      :status="offer.current_promotion.status"
      :reward-percent="offer.current_promotion.incentive.bonus_display"
      :expiration="offer.current_promotion.availability.end_date"
      :start="offer.current_promotion.availability.start_date"
      :current-number="offer.current_promotion.availability.inventory.adjusted_avail_payment_amount"
      :total-number="offer.current_promotion.availability.inventory.adjusted_total_payment_amount"
      :min-purchase="offer.current_promotion.incentive.minimum_payment"
      :max-purchase="offer.current_promotion.incentive.adjusted_user_payment_limit"
    />
    <consumer-gift-card-amount :offer="offer" :partner-id="partnerId" />
    <auth-info-box class="mt-5" />
    <swap-auth-and-register v-if="$vuetify.breakpoint.xsOnly" style="width: -webkit-fill-available" class="mt-5" />
    <auth-and-register v-else class="mt-5" />
  </div>
</template>

<script>
import _get from 'lodash/get';
import ConsumerGiftCardInfoModal from '../../consumer-gift-card/components/ConsumerGiftCardInfoModal.vue';
import MerchantsModal from '../../modals/MerchantsModal.vue';
import PayAndGetOffer from '../../pay-and-get/PayAndGetOffer.vue';
import ConsumerGiftCardAmount from '../../consumer-gift-card/components/ConsumerGiftCardAmount.vue';
import AuthInfoBox from '../../authentication/AuthInfoBox.vue';
import AuthAndRegister from '../../authentication/AuthAndRegister.vue';
import SwapAuthAndRegister from '../../authentication/SwapAuthAndRegister.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    offer: {
      type: Object,
    },
    publisher: {
      type: Object,
    },
    partnerId: {
      type: String,
    },
  },
  components: { PayAndGetOffer, MerchantsModal, ConsumerGiftCardInfoModal, ConsumerGiftCardAmount, AuthInfoBox, SwapAuthAndRegister, AuthAndRegister },
  name: 'purchase-consumer-gift-card-auth',
  computed: {
    ...mapGetters('ui', ['currentLocale']),
    branding() {
      return this.offer.offer_branding || {};
    },
    restricted() {
      return _get(this.offer, 'features.restricted_to_members', false);
    },
    currentPromotionBrandingImage() {
      return _get(this.offer, `current_promotion.branding.images.showcases[${this.currentLocale}][0]`, null);
    },
    currentPromotionBrandingLabel() {
      return _get(this.offer, `current_promotion.branding.label[${this.currentLocale}]`, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@media ($sm-min) {
  ::v-deep .purchase-promotion-progress-bar .h-showcase-image {
    width: 235px;
  }

  ::v-deep .purchase-promotion-progress-bar .h-content {
    flex-grow: 1;
    padding: 0;

    align-self: center;
  }
  .purchase-promotion-progress-bar {
    display: flex;
    gap: var(--gap);
    padding: var(--gap);
  }
}

.link-merchants {
  margin: var(--gap) 0 var(--gap-xsmall) 0;
}

.purchase-promotion-progress-bar {
  border: var(--border-thin) solid var(--color-border) !important;

  border-radius: var(--border-radius);
}

.consumer-gift-card-auth {
  padding: var(--gap);

  border: var(--border-thin) solid var(--color-border);
}
</style>
